import { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { userSession } from '../utils/userSession.js';

export default function CancelSubscription({ isOpen, onClose, partnerId, onSuccess }) {
  const [isLoading, setIsLoading] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(
        'https://r7ej0e9i28.execute-api.ap-southeast-2.amazonaws.com/dev/cancel-subscription',
        { 
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            partnerId,
            userId: userSession.getUserId()
          })
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.details || errorData.error || 'Failed to cancel subscription');
      }

      if (onSuccess) {
        await onSuccess();
      }
      onClose();
    } catch (error) {
      console.error('Error cancelling subscription:', error);
      // You might want to show this error to the user
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 z-50 flex justify-center items-center">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-xl font-semibold text-gray-900">Cancel Subscription</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <XMarkIcon className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6 bg-gray-50">
          <div className="mb-6">
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Are you sure you want to cancel?
            </h3>
            <p className="text-sm text-gray-600">
              Your subscription will be cancelled at the end of your current billing period. You will:
            </p>
            <ul className="mt-2 space-y-1 text-sm text-gray-600">
              <li>• Lose access to partner features</li>
              <li>• Be removed from the partners directory</li>
              <li>• No longer see live analytics</li>
            </ul>
          </div>

          <div className="flex space-x-4">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="flex-1 rounded-md border border-gray-300 px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
            >
              Keep Subscription
            </button>
            <button
              onClick={handleConfirm}
              disabled={isLoading}
              className="flex-1 rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white hover:bg-red-500 disabled:bg-red-400"
            >
              {isLoading ? 'Cancelling...' : 'Cancel Subscription'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 